import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import qualificationStructureService from './services/qualificationStructureService';

const PPLM_CONTEXT = 'PeopleManagers';

const PeopleManagersContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getGlobalPeopleManagersPermissions } = qualificationStructureService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getGlobalPeopleManagersPermissions}
      permissionToCheck={permissionToCheck}
      contextName={PPLM_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default PeopleManagersContext;
